import Axios from 'axios'
import { config } from '../../../Config'

class ApiBase {
  get = url => new Promise((resolve, reject) => {
    Axios.get(`${config.CovidAPI}${url}`)
      .then(response => {  this._setResp(response, resolve, reject) })
      .catch(err => { reject(err) })
  })

  post = (url, data) => new Promise((resolve, reject) => {
    Axios.post(`${config.CovidAPI}${url}`, data)
      .then(response => this._setResp(response, resolve, reject))
      .catch(err => reject(err))
  })

  _setResp = (response, resolve, reject) => {
    if (response.status !== 200) {
      reject(response.statusText)
    } else {
        resolve(response.data)
    }
  }
}

const apiBase = new ApiBase()

export default apiBase